import { useQuery, useQueryClient } from 'react-query';
import { api } from '../../../api';
import { useContext } from 'react';
import { ToastContext } from '@weezevent/nacre';

export const useFinanceEntity = (id, { successUpdateToast, enabled = true }) => {
    const queryKey = ['finance-entity', id];
    const toaster = useContext(ToastContext);
    const client = useQueryClient();

    const { data, isLoading } = useQuery(
        queryKey,
        () => {
            return api.financeEntities.getById(id);
        },
        {
            onError: error => {
                const { detail } = error.response;
                toaster.error(detail);
            },
            enabled
        }
    );

    const update = newData =>
        api.financeEntities
            .update(data.id, newData)
            .then(res => {
                toaster.success(successUpdateToast);
                client.setQueryData(queryKey, res.response);
            })
            .catch(error => {
                const { detail } = error.response;
                if (typeof detail === 'string') {
                    toaster.error(detail);
                } else {
                    throw error;
                }
            })
            .catch(error => {
                toaster.error('Unknown error');
                throw error;
            });

    return {
        data,
        id: data?.id,
        isLoading,
        update
    };
};
